import ReactLinksBaseController from "../react_links_base_controller";

export default ReactLinksBaseController;
